import { useEffect, useState } from 'react'

import Modal from '@components/Modal'
import type { Product } from '@lib/types/product'
import type { CollectionProducts } from '@lib/types/collection'
import { getProductBySlug } from '@lib/operations/product'
import ProductView from '@components/product/ProductView'

type QuickShopModalProps = {
	productId: string | null
	onClose: () => void
	collectionProducts: CollectionProducts
}

export default function QuickShopModal({
	productId,
	onClose,
	collectionProducts
}: QuickShopModalProps) {
	const [product, setProduct] = useState<Product | null>(null)
	const [loading, setLoading] = useState(false)

	useEffect(() => {
		const fetchProduct = async () => {
			if (!productId) return
			setLoading(true)
			try {
				const foundProduct = collectionProducts.find((p) => p.id === productId)
				if (foundProduct && foundProduct.handle) {
					const productData = await getProductBySlug(foundProduct.handle)
					if (productData) {
						setProduct(productData)
					} else {
						onClose()
					}
				} else {
					onClose()
				}
			} catch (error) {
				console.error('Error fetching product:', error)
				onClose()
			} finally {
				setLoading(false)
			}
		}

		fetchProduct()
	}, [productId, collectionProducts, onClose])

	const handleAddToCart = () => {
		onClose()
	}

	const renderContent = () => {
		if (loading) {
			return (
				<div className="flex items-center justify-center w-full h-64">
					<i className="fa-light fa-spinner-third fa-spin text-3xl text-gray-400" />
				</div>
			)
		}

		if (!product) {
			return (
				<div className="flex items-center justify-center w-full h-64">
					<span className="text-gray-500">Product not found</span>
				</div>
			)
		}

		return <ProductView product={product} showFavorite={false} onAddToCart={handleAddToCart} />
	}

	if (!productId) return null

	return (
		<Modal isOpen={!!productId} closeModal={onClose} desktopStyle="floating">
			<div className="p-6">{renderContent()}</div>
		</Modal>
	)
}
